module.exports = __webpack_public_path__ + "img/Type-the-certificate.89747832.png";